<div *ngrxLet="viewModel$; let model;"
     class="flex items-center h-[25px] group main-container">

  <app-column-sorting-button [columnName]="model.params?.displayName"
                             [sortDirection]="model?.sortDirection"
                             [sortIndex]="model?.sortIndex"
                             [sortingDisabled]="!model.params?.enableSorting"
                             (sortingChange)="onSortRequested($event, model.params)"/>

  @if (model.params?.enableMenu) {
    <div class="filterMenu
                h-6 w-6 flex items-center justify-center mt-[1px]
                rounded-[50%] cursor-pointer
                text-neutral-60 hover:bg-[#F5F5F5] hover:text-neutral-10
                invisible group-hover:visible"
         (click)="onMenuClick(model.params)">
      <mat-icon svgIcon="menu" class="h-5 w-5"></mat-icon>
    </div>
  }

</div>
